"use client";

import dynamic from "next/dynamic";

const Scene = dynamic(() => import("@/components/storefront/void-scene").then((mod) => mod.VoidScene), { ssr: false });

export function VoidSceneMount() {
  return <Scene />;
}
